import { render, staticRenderFns } from "./_BachelorAdditional.vue?vue&type=template&id=42d00b74"
import script from "./_BachelorAdditional.vue?vue&type=script&lang=js"
export * from "./_BachelorAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports